import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { customMedia } from '../../common/customMedia'
import { Reveal, Animation } from 'react-genie'

import { Image } from '../../common/Image'
import { MyButton } from '../../common/MyButton'

export interface Props {
  showButton: boolean
}

export const Mission = (props: Props) => {
  const { showButton } = props

  return (
    <Container showButton={showButton}>
      <Reveal delay={500} animation={Animation.FadeIn}>
        <MissionTitle>MISSION</MissionTitle>
      </Reveal>

      <MissionContainer>
        <Reveal delay={700} animation={Animation.FadeInUp}>
          <Medicine>
            <MissionIconWrapper>
              <Image path='mission_mesicine@2x.png' />
            </MissionIconWrapper>
            <MissionText>
              スピーディかつ<br />正確に処方薬を<br />ご用意する
            </MissionText>
          </Medicine>
        </Reveal>

        <Reveal delay={900} animation={Animation.FadeInUp}>
          <Prescription>
            <MissionIconWrapper>
              <Image path='mission_prescription@2x.png' />
            </MissionIconWrapper>
            <MissionText>
              処方せんから<br />情報を読み取り<br />解析と服薬指導を行う
            </MissionText>
          </Prescription>
        </Reveal>

        <Reveal delay={1100} animation={Animation.FadeInUp}>
          <Tablet>
            <MissionIconWrapper>
              <Image path='mission_tablet@2x.png' />
            </MissionIconWrapper>
            <MissionText>
              予防や在宅ケアなどの<br />お薬に関わる情報を<br />丁寧にご案内する
            </MissionText>
          </Tablet>
        </Reveal>
      </MissionContainer>
      {showButton && 
        <Reveal delay={1300} animation={Animation.FadeInUp}>
          <ButtonWrapper>
            <Link to='/about/company'>
              <MyButton color='white2' text='会社概要' />
            </Link>
          </ButtonWrapper>
        </Reveal>
      }
    </Container>
  )
}

const Container = styled.div<{showButton: boolean}>`
  ${customMedia.lessThan("medium")`
  `}
  ${props => customMedia.greaterThan("medium")`
    height: ${props.showButton ? '524px' : '441px'};
  `}

  background-color: #C92F68;
  overflow: hidden;
`

const MissionTitle = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 2.6rem;
    margin-top: 25px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 3.6rem;
    margin-top: 60px;
  `}

  color: #fff;
  font-family: 'Quicksand', sans-serif;
  letter-spacing: 0.1em;
  text-align: center;
`

const MissionContainer = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 0 auto;
    width: 260px;
  `}
  ${customMedia.greaterThan("medium")`
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    margin-top: 43px;
    margin-bottom: 60px;
  `}
`

const MissionIconWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    width: 90px;
  `}
  ${customMedia.greaterThan("medium")`
    margin: 0 auto;
    width: 135px;
  `}
`

const Medicine = styled.div`
  ${customMedia.lessThan("medium")`
    display: -webkit-flex;
    display: flex;
    margin-top: 30px;
  `}
  ${customMedia.greaterThan("medium")`
    width: 260px;
  `}

  position: relative;
`

const Prescription = styled.div`
  ${customMedia.lessThan("medium")`
    display: -webkit-flex;
    display: flex;
    margin-top: 30px;
  `}
  ${customMedia.greaterThan("medium")`
    width: 260px;
  `}

  position: relative;
`

const Tablet = styled.div`
  ${customMedia.lessThan("medium")`
    display: -webkit-flex;
    display: flex;
    margin-top: 30px;
    margin-bottom: 13px;
  `}
  ${customMedia.greaterThan("medium")`
    width: 260px;
  `}

  position: relative;
`

const MissionText = styled.div`
  ${customMedia.lessThan("medium")`
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    font-size: 1.4rem;
    margin-left: 30px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    text-align: center;
    position: absolute;
    top: 180px;
    width: 100%;
  `}

  color: #fff;
  font-weight: bold;
  letter-spacing: 0.02em;
`

const ButtonWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 20px 0 30px;
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 130px;
  `}
`